import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";

export default class Platform extends Model {
    static entity = 'platforms';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'name',
    };

    static fields() {
        return {
            id: this.uid(),
            name: this.string(''),

            created_at: this.string(''),
            updated_at: this.string(''),
        }
    }

    declare id: number;
    declare name: string;
}
